import { AutoComplete } from "antd";

const normalValues = [
    { value: '4.5-11.0 x10^3/µL', label: 'WBC: 4.5-11.0 x10^3/µL' },
    { value: '13.5-17.5 g/dL', label: 'Hemoglobin (Male): 13.5-17.5 g/dL' },
    { value: '12.0-15.5 g/dL', label: 'Hemoglobin (Female): 12.0-15.5 g/dL' },
    { value: '150-450 x10^3/µL', label: 'Platelets: 150-450 x10^3/µL' },
    { value: '3.5-5.0 mmol/L', label: 'Potassium: 3.5-5.0 mmol/L' },
    { value: '135-145 mmol/L', label: 'Sodium: 135-145 mmol/L' },
    { value: '70-110 mg/dL', label: 'Fasting Glucose: 70-110 mg/dL' },
    { value: '0.6-1.2 mg/dL', label: 'Creatinine: 0.6-1.2 mg/dL' },
    { value: '7-20 mg/dL', label: 'BUN: 7-20 mg/dL' },
    { value: '8.5-10.5 mg/dL', label: 'Calcium: 8.5-10.5 mg/dL' }
];

const NormalValueInput = ( {value, onChange, className} ) => {
    return (
        <AutoComplete
            className={`w-full ${className}`}
            options={normalValues}
            placeholder="Select unit..."
            value={value}
            onSelect={(value) => {
                // console.log('Selected:', value)
                onChange(value);
            }}
            onSearch={(searchText) => {
                // console.log('Searching for:', searchText);
                // onChange(searchText);
            }}
        />
    );
};


export default NormalValueInput;